// client/src/components/pages/ErrorDetection/ruleTemplates.ts (WBE batch, ST-00223)
//
// The sample rules the rule editor's Templates panel offers. Rule SQL runs in the server's
// read-only sandbox on PostgreSQL (utils/userQuery), so they are PostgreSQL against
// lexi_bridge_data_view — the corrected data, amendments included. They used to be T-SQL
// ([Ticket No], GETDATE(), LexiBridgeDataView) and failed when run.

/** A sample rule the Templates panel offers. */
export interface SampleQuery {
  name: string;
  description: string;
  icon: string;
  query: string;
}

// Ticket timestamps are SAST wall-clock digits, so "now" is NOW() AT TIME ZONE
// 'Africa/Johannesburg' (CLAUDE.md, ST-00162).
export const sampleQueries: SampleQuery[] = [
  {
    name: 'Duplicate Ticket Numbers',
    description: 'Same ticket number appears more than once in the last 30 days',
    icon: '01',
    query: `SELECT ticket_no AS "TicketNo", COUNT(*) AS "DuplicateCount"
FROM lexi_bridge_data_view
WHERE ticket_no IS NOT NULL AND ticket_no <> ''
  AND ticket_timestamp >= (NOW() AT TIME ZONE 'Africa/Johannesburg') - INTERVAL '30 days'
GROUP BY ticket_no
HAVING COUNT(*) > 1`,
  },
  {
    name: 'Missing Receipt Locations',
    description: 'Tickets of the last 30 days with no receipt location',
    icon: '02',
    query: `SELECT ticket_no AS "TicketNo", ticket_timestamp AS "TicketTimestamp",
       dispatch_location AS "DispatchLocation", receipt_location AS "ReceiptLocation"
FROM lexi_bridge_data_view
WHERE (receipt_location IS NULL OR receipt_location = '')
  AND ticket_timestamp >= (NOW() AT TIME ZONE 'Africa/Johannesburg') - INTERVAL '30 days'`,
  },
  {
    name: 'Invalid Weight Values',
    description: 'Tickets of the last 30 days with a zero or negative nett weight',
    icon: '03',
    query: `SELECT ticket_no AS "TicketNo", nett_weight AS "NettWeight",
       dispatch_location AS "DispatchLocation", receipt_location AS "ReceiptLocation"
FROM lexi_bridge_data_view
WHERE nett_weight <= 0
  AND ticket_timestamp >= (NOW() AT TIME ZONE 'Africa/Johannesburg') - INTERVAL '30 days'`,
  },
  {
    name: 'Future Dated Tickets',
    description: 'Ticket timestamps later than now',
    icon: '04',
    query: `SELECT ticket_no AS "TicketNo", ticket_timestamp AS "TicketTimestamp",
       dispatch_location AS "DispatchLocation"
FROM lexi_bridge_data_view
WHERE ticket_timestamp > (NOW() AT TIME ZONE 'Africa/Johannesburg')`,
  },
];
